export default [
  {
    img: "das-neue-miteinander",
    title: "Das neue Miteinander",
    subTitle: "Eine Psychologie der solidarischen Gemeinschaft",
    description: require("@/content/books/das-neue-miteinander.md"),
    isbn: "978-3958835580",
    publisher: "Fischer & Gann",
    publishingYear: "2022",
    buyLinks: [
      {
        type: "jokers",
        link:
          "https://www.jokers.de/artikel/buch/das-neue-miteinander_36328006-1"
      },
      {
        type: "weltbild",
        link:
          "https://www.weltbild.de/artikel/ebook/das-neue-miteinander_36576646-1"
      },
      { type: "amazon", link: "https://amzn.to/34I9ZVC" }
    ]
  },
  {
    img: "alzheimer",
    title: "Gespräche bei Demenz und Alzheimer",
    subTitle: "Gute Kommunikation mit Erkrankten, Ärzten und Pflegepersonal",
    description: require("@/content/books/alzheimer.md"),
    isbn: "978-3411756469",
    publisher: "Duden",
    publishingYear: "2020",
    buyLinks: [
      {
        type: "jokers",
        link:
          "https://www.jokers.de/artikel/buch/gespraeche-bei-demenz-und-alzheimer_26892227-1"
      },
      {
        type: "weltbild",
        link:
          "https://www.weltbild.de/artikel/buch/gespraeche-bei-demenz-und-alzheimer_26892227-1"
      },
      { type: "amazon", link: "https://amzn.to/3cQWkdo" }
    ]
  },
  {
    img: "kummer-von-der-seele-schreiben",
    title: "Den Kummer von der Seele schreiben",
    subTitle: "Mein persönliches Trauerbegleitbuch",
    description: require("@/content/books/den-kummer-von-der-seele-schreiben.md"),
    isbn: "978-3579073163",
    publisher: "Gütersloher Verlagshaus",
    publishingYear: "2019",
    buyLinks: [
      {
        type: "jokers",
        link:
          "https://www.jokers.de/artikel/buch/den-kummer-von-der-seele-schreiben_25488237-1"
      },
      {
        type: "weltbild",
        link:
          "https://www.weltbild.de/artikel/buch/den-kummer-von-der-seele-schreiben_25488237-1"
      },
      { type: "amazon", link: "https://amzn.to/2OBNF2f" }
    ]
  },
  {
    img: "ich-will-dich-nicht-vergessen",
    title: "Ich will dich nicht vergessen",
    subTitle: "Ein Begleiter durch die Zeit der Trauer und des Abschiednehmens",
    description: require("@/content/books/ich-will-dich-nicht-vergessen.md"),
    isbn: "9783579073132",
    publisher: "Gütersloher Verlagshaus",
    publishingYear: "2018",
    buyLinks: [
      {
        type: "jokers",
        link:
          "https://www.jokers.de/artikel/buch/ich-will-dich-nicht-vergessen_23825890-1"
      },
      {
        type: "weltbild",
        link:
          "https://www.weltbild.de/artikel/buch/ich-will-dich-nicht-vergessen_23825890-1"
      },
      { type: "amazon", link: "https://amzn.to/2DfgAXN" }
    ]
  },
  {
    img: "trauma",
    title: "Trauma",
    subTitle: "Verstehen und Heilen",
    description: require("@/content/books/trauma.md"),
    isbn: "9-783711-000880",
    publisher: "Ecowin Verlag",
    publishingYear: "2016",
    buyLinks: [
      {
        type: "jokers",
        link: "https://www.jokers.de/artikel/buch/trauma_21286591-1"
      },
      {
        type: "weltbild",
        link: "https://www.weltbild.de/artikel/buch/trauma_21286591-1"
      },
      { type: "amazon", link: "https://amzn.to/2OBF8fU" }
    ]
  },
  {
    img: "kinder-und-trauma",
    title: "Kinder und Trauma",
    subTitle:
      "Was Kinder brauchen, die einen Unfall, einen Todesfall, eine Katastrophe, Trennung, Missbrauch oder Mobbing erlebt haben",
    description: require("@/content/books/kinder-und-trauma.md"),
    isbn: "3525462255",
    publisher: "Vandenhoeck & Ruprecht",
    publishingYear: "2005",
    buyLinks: [
      {
        type: "jokers",
        link: "https://www.jokers.de/artikel/buch/kinder-und-trauma_14744236-1"
      },
      {
        type: "weltbild",
        link:
          "https://www.weltbild.de/artikel/buch/kinder-und-trauma_14744236-1"
      },
      { type: "amazon", link: "https://amzn.to/2RNotYJ" }
    ]
  },
  {
    img: "wohnst-du-jetzt-im-himmel",
    title: "Wohnst du jetzt im Himmel?",
    subTitle: "Ein Abschieds- und Erinnerungsbuch für trauernde Kinder",
    description: require("@/content/books/wohnst-du-jetzt-im-himmel.md"),
    isbn: "3-579-06807-5",
    publisher: "Gütersloher Verlagshaus",
    publishingYear: "2016",
    buyLinks: [
      {
        type: "jokers",
        link:
          "https://www.jokers.de/artikel/buch/wohnst-du-jetzt-im-himmel_14743202-1"
      },
      {
        type: "weltbild",
        link:
          "https://www.weltbild.de/artikel/buch/wohnst-du-jetzt-im-himmel_14743202-1"
      },
      { type: "amazon", link: "https://amzn.to/2Plc1Te" }
    ]
  },
  {
    img: "wenn-trauma-und-trauer-aufeinandertreffen",
    title: "Wenn Trauma und Trauer aufeinandertreffen",
    subTitle:
      "Betroffenen helfen, neuen Lebensmut zu finden (Edition Leidfaden)",
    description: require("@/content/books/wenn-trauma-und-trauer-aufeinandertreffen.md"),
    isbn: "978-3-525-40280-1",
    publisher: "Vandenhoeck & Ruprecht",
    publishingYear: "2017",
    buyLinks: [
      {
        type: "jokers",
        link:
          "https://www.jokers.de/artikel/buch/wenn-trauma-und-trauer-aufeinandertreffen_22535924-1"
      },
      {
        type: "weltbild",
        link:
          "https://www.weltbild.de/artikel/buch/wenn-trauma-und-trauer-aufeinandertreffen_22535924-1"
      },
      { type: "amazon", link: "https://amzn.to/2zG31gH" }
    ]
  },
  {
    img: "reden-ist-gold",
    title: "Reden ist Gold",
    subTitle: "Wie Gespräche die Liebe stärken",
    description: require("@/content/books/reden-ist-gold.md"),
    isbn: "978-3-8436-0746-9",
    publisher: "Patmos Verlag",
    publishingYear: "2016",
    buyLinks: [
      {
        type: "jokers",
        link:
          "https://www.jokers.de/artikel/buch/reden-ist-gold-wie-gespraeche-die-liebe-staerken_21110479-1"
      },
      {
        type: "weltbild",
        link:
          "https://www.weltbild.de/artikel/buch/reden-ist-gold-wie-gespraeche-die-liebe-staerken_21110479-1"
      },
      { type: "amazon", link: "https://amzn.to/2PlVJtr" }
    ]
  },
  {
    img: "dietrich-bonhoeffer",
    title: "Dietrich Bonhoeffer",
    subTitle: "Finde deinen eigenen Weg",
    description: require("@/content/books/dietrich-bonhoeffer.md"),
    isbn: "9783579071510",
    publisher: "Gütersloher Verlagshaus",
    publishingYear: "2015",
    buyLinks: [
      {
        type: "jokers",
        link:
          "https://www.jokers.de/artikel/buch/dietrich-bonhoeffer-finde-deinen-eigenen-weg_19858543-1"
      },
      {
        type: "weltbild",
        link:
          "https://www.weltbild.de/artikel/buch/dietrich-bonhoeffer-finde-deinen-eigenen-weg_19858543-1"
      },
      { type: "amazon", link: "https://amzn.to/2PmQRUI" }
    ]
  },
  {
    img: "so-will-ich-leben",
    title: "So will ich leben",
    subTitle: "Ein Zukunftsplaner für Kinder",
    description: require("@/content/books/so-will-ich-leben.md"),
    isbn: "9783745023145",
    publisher: "epubli",
    publishingYear: "2017",
    buyLinks: [
      {
        type: "jokers",
        link: "https://www.jokers.de/artikel/buch/so-will-ich-leben_23656238-1"
      },
      {
        type: "weltbild",
        link:
          "https://www.weltbild.de/artikel/buch/so-will-ich-leben_23656238-1"
      },
      { type: "amazon", link: "https://amzn.to/2AWC1eW" }
    ]
  },
  {
    img: "mobbing-bei-kindern",
    title: "Mobbing bei Schulkindern",
    subTitle: "Hilfe und Vorbeugung",
    description: require("@/content/books/mobbing-bei-kindern.md"),
    isbn: "978-3332017878",
    publisher: "Urania",
    publishingYear: "2006",
    buyLinks: [{ type: "amazon", link: "https://amzn.to/2DdT8dJ" }]
  },
  {
    img: "wenn-die-familie-zerbricht",
    title: "Wenn die Familie zerbricht",
    subTitle: "Hilfen für Kinder bei Scheidung und Trennung",
    description: require("@/content/books/wenn-die-familie-zerbricht.md"),
    isbn: "978-3451660276",
    publisher: "Urania",
    publishingYear: "2013",
    buyLinks: [{ type: "amazon", link: "https://amzn.to/2Dd2u9s" }]
  }
];
